/* ps-sticky-buy.js -- Primostore. Authored in the hub, not by Impulse.
   Adds (a) a sticky buy bar on mobile once the real Add to Cart scrolls out of
   view, and (b) a trust block under the buy box. It never builds a second cart
   form: the bar's button clicks Impulse's own button, so variant, quantity and
   price can never disagree with what the shopper selected. */
(function () {
  "use strict";
  var TRUST = {
    ar: [
      {icon:"banknote",h:"الدفع عند الاستلام"},
      {icon:"truck",h:"التوصيل خلال 2-3 أيام (2-5 أيام خارج القاهرة)"},
      {icon:"package",h:"شحن مجاني فوق EGP 1,250"},
      {icon:"shield-check",h:"دفع آمن"},
      {icon:"rotate-ccw",h:"إرجاع خلال 14 يوم"}
    ],
    en: [
      {icon:"banknote",h:"Cash on Delivery"},
      {icon:"truck",h:"Delivery in 2-3 Days (2-5 days outside Cairo)"},
      {icon:"package",h:"Free Shipping over EGP 1,250"},
      {icon:"shield-check",h:"Secure Checkout"},
      {icon:"rotate-ccw",h:"14-Day Returns"}
    ]
  };

  /* Real Lucide icon path data (lucide-static v1.61.0, ISC licence),
     fetched 2026-10-24 -- not hand-drawn. Native 24x24 viewBox kept so
     stroke-width:2 scales the same way Lucide's own components render
     it; only the rendered width/height (18px, via .ps-trust-icon svg)
     shrinks it for the chip. */
  var ICON_SHAPES = {
    banknote: [["rect",{width:"20",height:"12",x:"2",y:"6",rx:"2"}],
      ["circle",{cx:"12",cy:"12",r:"2"}],["path",{d:"M6 12h.01M18 12h.01"}]],
    truck: [["path",{d:"M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"}],
      ["path",{d:"M15 18H9"}],
      ["path",{d:"M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"}],
      ["circle",{cx:"17",cy:"18",r:"2"}],["circle",{cx:"7",cy:"18",r:"2"}]],
    package: [["path",{d:"M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"}],
      ["path",{d:"M12 22V12"}],["polyline",{points:"3.29 7 12 12 20.71 7"}],
      ["path",{d:"m7.5 4.27 9 5.15"}]],
    "shield-check": [["path",{d:"M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"}],
      ["path",{d:"m9 12 2 2 4-4"}]],
    "rotate-ccw": [["path",{d:"M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"}],
      ["path",{d:"M3 3v5h5"}]]
  };

  function ready(fn) {
    if (document.readyState !== "loading") { fn(); }
    else { document.addEventListener("DOMContentLoaded", fn); }
  }

  function findAddButton() {
    return document.querySelector('form[action*="/cart/add"] button[name="add"]')
        || document.querySelector('form[action*="/cart/add"] [type="submit"]');
  }

  function priceText() {
    var el = document.querySelector(".product__price, .product-single__price, [data-product-price]");
    return el ? el.textContent.trim().split("\n")[0] : "";
  }

  /* One Lucide icon per trust-badge item, replacing the single repeated
     checkmark -- the thing the 2026-10-24 store-ux audit named as the
     reason the row read as a bullet checklist, not a badge row. */
  function icon(name) {
    var s = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    s.setAttribute("viewBox", "0 0 24 24");
    s.setAttribute("aria-hidden", "true");
    s.setAttribute("fill", "none");
    s.setAttribute("stroke", "currentColor");
    s.setAttribute("stroke-width", "2");
    s.setAttribute("stroke-linecap", "round");
    s.setAttribute("stroke-linejoin", "round");
    (ICON_SHAPES[name] || []).forEach(function (shape) {
      var el = document.createElementNS("http://www.w3.org/2000/svg", shape[0]);
      for (var k in shape[1]) { el.setAttribute(k, shape[1][k]); }
      s.appendChild(el);
    });
    return s;
  }

  function buildTrust(addBtn) {
    if (document.querySelector(".ps-trust")) { return; }
    var lang = (document.documentElement.getAttribute("lang") || "en").toLowerCase();
    var rows = lang.indexOf("ar") === 0 ? TRUST.ar : TRUST.en;
    var ul = document.createElement("ul");
    ul.className = "ps-trust";
    rows.forEach(function (r) {
      var li = document.createElement("li");
      /* Icon chip wrapper -- gap on the li (below) is what spaces this
         from the label, deliberately never a margin-left/right on this
         element, so dir="rtl" mirrors it for free (store-ux flag,
         2026-10-24: a hard-coded physical margin is the one way this
         silently breaks only on the Arabic page). */
      var chip = document.createElement("span");
      chip.className = "ps-trust-icon";
      chip.appendChild(icon(r.icon));
      li.appendChild(chip);
      var span = document.createElement("span");
      var b = document.createElement("b");
      b.textContent = r.h;
      span.appendChild(b);
      li.appendChild(span);
      ul.appendChild(li);
    });
    /* Position history, both same day: first shipped afterend-of-form
       (below Add to Cart); moved to afterend-of-price (matching Amazon's
       #icon-farm-container / Noon's delivery block / §14.7's trust-before-
       variants order) once the buy-box-buried complaint came up; Abdo then
       asked for it back under the call-to-action specifically ("the icons
       for cash on delivery we can add under the call to action") after
       seeing the price-anchored version live. This is his explicit,
       final placement -- not a reversion to the ORIGINAL position by
       accident, a deliberate return to it stated in his own words. */
    var form = addBtn.closest("form");
    (form || addBtn.parentNode).insertAdjacentElement("afterend", ul);
  }

  /* Title clamp expand/collapse. §14.7's 20/Semibold title is CSS-clamped to
     2 lines (see primostore-system.css); this adds the caret ONLY when the
     title is actually truncated -- scrollHeight > clientHeight is the real
     signal, not title.length, since character count doesn't account for
     font metrics or viewport width. A short title gets no button at all. */
  function initTitleClamp() {
    var title = document.querySelector(".product-single__title");
    if (!title) { return; }
    if (title.scrollHeight <= title.clientHeight + 1) { return; }
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "ps-title-expand-btn";
    var lang = (document.documentElement.getAttribute("lang") || "en").toLowerCase();
    var MORE = lang.indexOf("ar") === 0 ? "عرض المزيد" : "Show more";
    var LESS = lang.indexOf("ar") === 0 ? "عرض أقل" : "Show less";
    btn.textContent = MORE;
    btn.addEventListener("click", function () {
      var open = title.classList.toggle("ps-title-expanded");
      btn.textContent = open ? LESS : MORE;
    });
    title.insertAdjacentElement("afterend", btn);
  }

  function buildBar(addBtn) {
    if (document.querySelector(".ps-sticky-buy")) { return null; }
    var bar = document.createElement("div");
    bar.className = "ps-sticky-buy";
    bar.setAttribute("data-shown", "0");

    var meta = document.createElement("div");
    meta.className = "ps-sticky-buy__meta";
    var price = document.createElement("span");
    price.className = "ps-sticky-buy__price";
    price.textContent = priceText();
    meta.appendChild(price);

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "ps-sticky-buy__btn";
    btn.textContent = (addBtn.textContent || "").trim() || "Add to cart";
    btn.addEventListener("click", function () { addBtn.click(); });

    var inner = document.createElement("div");
    inner.className = "ps-sticky-buy__inner";

    /* Variant swatches. Cloned from Impulse's OWN labels so the colour chip
       art comes along, then wired to click the original -- the bar never owns
       variant state, it only proxies. Ids and `for` attributes are stripped or
       the clone would hijack the real radio it was copied from. */
    var swatches = buildSwatches();

    inner.appendChild(meta);
    if (swatches) { inner.appendChild(swatches.el); }
    inner.appendChild(btn);
    bar.appendChild(inner);
    document.body.appendChild(bar);
    return { bar: bar, price: price, btn: btn, swatches: swatches };
  }

  /* Find the option group worth mirroring: the first with 2+ real choices. */
  function variantInputs() {
    /* Impulse renders the variant radios OUTSIDE the <form> and links them
       with form="AddToCartForm-...". Measured on the live page 2026-08-18:
       zero radios inside the form element, four in the document. Querying
       the form alone silently found nothing and the swatches never rendered,
       which is exactly the kind of failure that looks like "the feature is
       missing" rather than "the selector is wrong". Match on data-index,
       Impulse's own variant marker, and keep the in-form case as a fallback
       so this still works if a future theme nests them properly. */
    var inputs = document.querySelectorAll(
      'input[type="radio"][data-index], '
      + 'form[action*="/cart/add"] input[type="radio"][name]');
    if (!inputs.length) { return []; }
    var groups = {};
    for (var i = 0; i < inputs.length; i++) {
      var n = inputs[i].getAttribute("name");
      (groups[n] = groups[n] || []).push(inputs[i]);
    }
    var best = [];
    for (var k in groups) {
      if (groups[k].length > best.length) { best = groups[k]; }
    }
    return best.length > 1 ? best : [];
  }

  function labelFor(input) {
    var id = input.getAttribute("id");
    if (id) {
      var l = document.querySelector('label[for="' + CSS_escape(id) + '"]');
      if (l) { return l; }
    }
    return input.closest("label") || input.nextElementSibling;
  }

  function CSS_escape(s) {
    return (window.CSS && CSS.escape) ? CSS.escape(s)
      : String(s).replace(/([^\w-])/g, "\\$1");
  }

  function buildSwatches() {
    var inputs = variantInputs();
    if (!inputs.length) { return null; }
    var wrap = document.createElement("div");
    wrap.className = "ps-sticky-buy__swatches";
    var buttons = [];
    inputs.forEach(function (input) {
      var src = labelFor(input);
      if (!src) { return; }
      var b = document.createElement("button");
      b.type = "button";
      b.className = "ps-sticky-buy__sw";
      var label = (input.value || src.textContent || "").trim();
      b.setAttribute("aria-label", label);
      b.title = label;
      var clone = src.cloneNode(true);
      stripIds(clone);
      b.appendChild(clone);
      b.addEventListener("click", function () { src.click(); });
      wrap.appendChild(b);
      buttons.push({ btn: b, input: input });
    });
    if (!buttons.length) { return null; }
    return { el: wrap, buttons: buttons };
  }

  function stripIds(node) {
    if (node.removeAttribute) {
      node.removeAttribute("id");
      node.removeAttribute("for");
      node.removeAttribute("name");
    }
    var kids = node.children || [];
    for (var i = 0; i < kids.length; i++) { stripIds(kids[i]); }
  }

  ready(function () {
    var addBtn = findAddButton();
    if (!addBtn) { return; }              /* not a product page */
    initTitleClamp();
    buildTrust(addBtn);
    var made = buildBar(addBtn);
    if (!made) { return; }

    /* Show the bar only once the real button is out of view. */
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        made.bar.setAttribute("data-shown", entries[0].isIntersecting ? "0" : "1");
      }, { rootMargin: "0px 0px -10px 0px" }).observe(addBtn);
    } else {
      made.bar.setAttribute("data-shown", "1");
    }

    /* Keep the bar honest when the shopper switches variant: mirror the real
       button's disabled state and re-read the rendered price. */
    var sync = function () {
      made.btn.disabled = !!addBtn.disabled;
      var p = priceText();
      if (p) { made.price.textContent = p; }
      /* Which swatch is live. With the name gone, the ring IS the answer to
         "which one am I buying", so it has to track the real input exactly. */
      if (made.swatches) {
        var shown = 0;
        made.swatches.buttons.forEach(function (pair) {
          /* Impulse flags an unavailable option value with a `disabled` CLASS
             on the input. Hiding here rather than at build time means the bar
             tracks availability as it changes when another option is picked,
             instead of freezing whatever was in stock on page load. */
          var out = pair.input.classList.contains("disabled");
          pair.btn.hidden = out;
          if (!out) { shown++; }
          var on = !!pair.input.checked;
          pair.btn.setAttribute("data-selected", on ? "1" : "0");
          pair.btn.setAttribute("aria-pressed", on ? "true" : "false");
        });
        /* If every colour is gone, drop the empty rail rather than leave a
           gap where a control used to be. */
        made.swatches.el.hidden = (shown === 0);
      }
    };
    if ("MutationObserver" in window) {
      new MutationObserver(sync).observe(addBtn,
        { attributes: true, attributeFilter: ["disabled", "aria-disabled"] });
    }
    document.addEventListener("change", function (e) {
      if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) {
        setTimeout(sync, 60);
      }
    });
    sync();
  });
})();
